import { acReportTypes } from '../acReduxExports'

const chargersHistoryReportInitialState: AcReportState = {
    chargingHistoryColumnHeaders: null,
    chargingHistoryData: null,
    chargingHistoryFiltersAppliedFromRedirection:false,
    chargingHistoryCount: 0,
    reportLoader: false,
    chargerLogsCount: 0,
    chargerLogsColumnHeaders: null,
    chargerLogsData: null,
    exceptionLogsCount: 0,
    exceptionLogsColumnHeaders: null,
    exceptionLogsData: null,
    chargingHistoryListTableProps: {
        view: 'list',
        sortBy: '',
        order: 'ascending',
        pageSize: 15,
        pageNumber: 1,
        searchTerm: ''
    },
    chargerLogsListTableProps: {
        view: 'list',
        sortBy: '',
        order: 'ascending',
        pageSize: 15,
        pageNumber: 1,
        searchTerm: ''
    },
    exceptionLogsListTableProps: {
        view: 'list',
        sortBy: '',
        order: 'ascending',
        pageSize: 15,
        pageNumber: 1,
        searchTerm: ''
    },
    chargerLogsFiltersRequestHash: null,
    sessionHistoryColumnHeaders: null,
    sessionHistoryData: null,
    sessionHistoryFiltersAppliedFromRedirection: false,
    sessionHistoryCount: 0,
    sessionHistoryListTableProps: {
        view: 'list',
        sortBy: '',
        order: 'ascending',
        pageSize: 15,
        pageNumber: 1,
        searchTerm: ''
    },
    sessionHistoryFiltersRequestHash: null,
    sessionHistorySearchHash: null,
    statusHistoryColumnHeaders: null,
    statusHistoryData: null,
    statusHistoryCount: 0,
    statusHistoryListTableProps: {
        view: 'list',
        sortBy: '',
        order: 'ascending',
        pageSize: 15,
        pageNumber: 1,
        searchTerm: ''
    },
    statusHistoryFiltersRequestHash: null,
    statusHistorySearchHash: null,
    statusHistoryFiltersAppliedFromRedirection: false
}

const acreportsReducer = (
	state: AcReportState = chargersHistoryReportInitialState,
	action: AcReportAction,
): AcReportState => {
	switch (action.type) {
		case acReportTypes.FETCH_AC_CHARGERS_HISTORY_DATA:
			return {
				...state,
				chargingHistoryColumnHeaders: action.chargingHistoryColumnHeaders,
				chargingHistoryData: action.chargingHistoryData,
				chargingHistoryCount: action.chargingHistoryCount,
			};
		case acReportTypes.SET_AC_REPORT_LOADER:
			return {
				...state,
				reportLoader: action.reportLoader,
			};
		case acReportTypes.SET_AC_CHARGER_LOGS_LIST_REQUEST_HASH:
			return {
				...state,
				chargerLogsFiltersRequestHash: action.chargerLogsFiltersRequestHash,
			};
		case acReportTypes.FETCH_AC_CHARGER_LOGS_DATA:
			return {
				...state,
				chargerLogsColumnHeaders: action.chargerLogsColumnHeaders,
				chargerLogsData: action.chargerLogsData,
				chargerLogsCount: action.chargerLogsCount,
			};
		case acReportTypes.SET_AC_CHARGING_HISTORY_LIST_TABLE_PROPS:
			return {
				...state,
				chargingHistoryListTableProps: action.chargingHistoryListTableProps,
			};
		case acReportTypes.SET_AC_CHARGER_LOGS_LIST_TABLE_PROPS:
			return {
				...state,
				chargerLogsListTableProps: action.chargerLogsListTableProps,
			};
		case acReportTypes.FETCH_AC_EXCEPTION_LOGS_DATA:
			return {
				...state,
				exceptionLogsColumnHeaders: action.exceptionLogsColumnHeaders,
				exceptionLogsData: action.exceptionLogsData,
				exceptionLogsCount: action.exceptionLogsCount,
			};

        case acReportTypes.SET_AC_EXCEPTION_LOGS_LIST_TABLE_PROPS:
                    return {
                        ...state,
                        exceptionLogsListTableProps: action.exceptionLogsListTableProps
                    }
        case acReportTypes.SET_AC_SESSION_HISTORY_LIST_TABLE_PROPS:
                    return {
                        ...state,
                        sessionHistoryListTableProps: action.sessionHistoryListTableProps
                    }
        case acReportTypes.SET_AC_STATUS_HISTORY_LIST_TABLE_PROPS:
                    return {
                        ...state,
                        statusHistoryListTableProps: action.statusHistoryListTableProps
                    }
        case acReportTypes.FETCH_AC_STATUS_HISTORY_DATA:
                    return {
                        ...state,
                        statusHistoryColumnHeaders: action.statusHistoryColumnHeaders,
                        statusHistoryData: action.statusHistoryData,
                        statusHistoryCount: action.statusHistoryCount,
                    }
        case acReportTypes.SET_AC_STATUS_HISTORY_LIST_REQUEST_HASH:
                    return {
                        ...state,
                        statusHistoryFiltersRequestHash: action.statusHistoryFiltersRequestHash,
                    }
        case acReportTypes.SET_AC_STATUS_HISTORY_FILTERS_APPLIED_FROM_REDIRECTION:
                    return {
                        ...state,
                        statusHistoryFiltersAppliedFromRedirection: action.statusHistoryFiltersAppliedFromRedirection,
                    }
        case acReportTypes.CLEAR_AC_STATUS_HISTORY_LIST_DATA:
                    return {
                        ...state,
                        statusHistoryColumnHeaders: null,
                        statusHistoryData: null,
                        statusHistoryCount: 0,
                    }
		default:
			return state;
	}
};

export default acreportsReducer